import httpClient from "@/lib/http-client"
import { generateImagePath } from "@/lib/utils"
import qs from "qs"
import Media from "../(admin)/modules/media/pages/Media"
import DefaultImageFile from "../../public/images/empty-img.jpg"

export interface FilterSearchParams {
  populate?: string
  filters: {
    [key: string]: {
      $containsi?: string
      $null?: boolean
      $notNull?: boolean
      $gt?: string
      $lt?: string
      $in?: string
      $eq?: string | boolean
      id?: {
        $eq?: string
        $in?: string[]
      }
      $not?: {
        $in?: string[]
      }
    } | any
    $and?: Array<{
      [key: string]: {
        $eq?: string | boolean
        $ne?: string | boolean | null
        $notNull?: boolean
        $not?: {
          $in?: string[]
        }
      }
    }>
  }
  sort: string
  publicationState?: string
  pagination?: {
    page?: string
    pageSize?: string
    current?: string
    start?: string
    limit?: string
    total?: string
    withCount?: boolean
  }
  locale?: string
}

const fetchPostByCategories = async (categoriesId: string[]) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    publicationState: "live",
    filters: {
      categories: {
        id: {
          $in: categoriesId,
        },
      },
    },
  }

  try {
    const response = await httpClient.get<any>(`posts?${qs.stringify(params, { encodeValuesOnly: true })}`)

    const modifiedResponse = response.data.map((post: any) => ({
      ...post,
      status: post.attributes.publishedAt ? "published" : "draft",
      publishedAt: post.attributes.publishedAt,
    }))

    return {
      data: modifiedResponse,
      meta: response.meta,
    }
  } catch (error) {}
}
const fetchPostId = async (id: number) => {
  try {
    const response = await httpClient.get<{ data: any }>(`posts/${id}?populate=*`)
    return response.data
  } catch (error) {
    console.error("Error fetching post by ID:", error)
    throw error
  }
}

export interface BaseSystem {
  id: string
  attributes: {
    name: string
    address: string
    hotline: string
  }
}

const fetchCategories = async (searchTerm?: string, populate?: string) => {
  const params: FilterSearchParams = {
    populate: populate ? "" : "*",
    sort: "createdAt:desc",
    filters: searchTerm
      ? {
          name: { $containsi: searchTerm },
        }
      : {},
  }
  return await httpClient.get(`categories`, {
    params,
  })
}

const fetchBaseSystems = async () => {
  const response = await httpClient.get<{ data: any }>(`base-systems?populate=*&sort=id:DESC`)
  return response.data
}

export const filterOption = (input: string, option?: { label: string; value: string }) =>
  normalizeText((option?.label ?? "").toLowerCase()).includes(normalizeText(input.toLowerCase()))

export const normalizeText = (text: string) => {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
}

const DefaultImage = DefaultImageFile.src as string

export { DefaultImage, fetchBaseSystems, fetchCategories, fetchPostByCategories, fetchPostId, Media }

export const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>, imgURL?: string) => {
  const target = e.currentTarget
  target.onerror = null

  if (imgURL && imgURL.length > 0) {
    target.src = generateImagePath(imgURL, "original")
  } else {
    target.src = DefaultImage
  }
}
